enum ImageAttachmentId {
  PROCESSING = "PROCESSING",
}

export default ImageAttachmentId;
